import { createSelector } from '@ngrx/store';
import { getOTPState } from '@store/reducers';
import { getOTPStatus } from '@store/reducers/otp/otp.reducer';

export const selectOTPState = createSelector(getOTPState, (state) => state);

export const selectOTPVerificationStatus = createSelector(selectOTPState, getOTPStatus);
